<script>
	import { onMount } from 'svelte'
	import { page } from '$app/stores'
	import { sendGTM } from '$lib/analytics'
	import { CONTACT_VARS } from '$lib/consts'
	import DynamicZone from '$lib/modules/cms/DynamicZone/DynamicZone.svelte'
	import { t } from '$lib/translations'
	import { Button } from '$lib/ui-woltair/components'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

	export let data

	const ERRORS = {
		404: t('web.error.404.message'),
		500: t('web.error.500.message')
	}

	$: message =
		/*$page.error.message.includes('Error:') ? $page.error.message : */ ERRORS[$page.status] ??
		ERRORS['500']

	onMount(() => {
		if ($page.error.code === 404) sendGTM('error', {}, { type: '404' })
	})
</script>

{#if data.errorComponents}
	<section class="page-wrapper z-20 flex flex-col items-center">
		<div class="flex w-full flex-col gap-4">
			<DynamicZone componentData={data.errorComponents} />
		</div>
	</section>
{:else}
	<section class="page-wrapper fallback">
		<div class="image-wrapper">
			<img src="/images/illustrations/woltair-house-error.svg" alt="Woltair" />
		</div>
		<div class="text-center">
			<h1 class="mb-6">{t('web.error.404.title')}</h1>
			<p class="mb-6">{message}</p>
			<Button href="/" cls="mt-2"><span>{t('web.ERROR.goback.linkText')}</span></Button>
			<Button
				href={CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE]?.phoneRef}
				cls="mt-2"
				icon={{ src: '/images/icons/icon-phone.svg', alt: t('web.error.404.icon.text') }}
				green
				>{CONTACT_VARS?.[PUBLIC_WOLTAIR_WEB_CODE]?.phoneNum}
			</Button>
		</div>
	</section>
{/if}

<style lang="scss">
	section.fallback {
		display: flex;
		align-items: center;
		margin-top: 150px;
		gap: 60px;

		@media only screen and (max-width: 760px) {
			margin-top: 30px;
			margin-top: 30px;
			flex-direction: column;
		}

		div {
			width: 50%;

			@media only screen and (max-width: 760px) {
				width: 100%;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}

		p {
			font-size: 24px;
			line-height: 30px;
		}
	}
</style>
